import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';

import { useSelector } from 'app/store';
import {
  linksLinkMcsSelector,
  linksLinkPhyRateSelector,
  linksLinkSignalLabelParamsSelector,
} from 'modules/links/slice';

import MCS, { MCSProps } from '../components/elements/MCS';

const MCSContainer = (props: Partial<MCSProps>) => {
  const { linkId } = useBottomPanel();

  const mcs = useSelector((state) => (linkId ? linksLinkMcsSelector(state, linkId) : undefined));
  const phyRate = useSelector((state) => (linkId ? linksLinkPhyRateSelector(state, linkId) : undefined));
  const infoText =
    'MCS (Modulation and Coding Scheme) represents the method used for transmitting data in Wi-Fi. A higher MCS value indicates a more advanced and efficient data transmission technique, leading to increased data rates in wireless communication. MCS values may be reduced in the presence of high channel usage, interference, or legacy devices.';
  const signalLabelParams = useSelector((state) =>
    linkId ? linksLinkSignalLabelParamsSelector(state, linkId) : undefined
  );

  return <MCS mcs={mcs} signalLabelParams={signalLabelParams} infoText={infoText} phyRate={phyRate} {...props} />;
};

export default MCSContainer;
